import {
  Wind, Activity, Stethoscope, Microscope, ScanLine, BedDouble, HeartPulse,
  Ambulance, TestTube, Droplets, Syringe, ShieldCheck, Moon, Clock, Baby, CalendarCheck,
} from "lucide-react";

export const HOSPITAL = {
  name: "Shri Sai Chest and Allergy Hospital",
  subName: "Dr Amol Shembatwad Chest and Respiratory Clinic",
  tagline: "Your lung protector.",
  established: "2023",
  beds: "20",
  address:
    "Nanded Malegaon Road, Opposite Walkaway Showroom, Salasar Square Building, Shetkari Putala, Taroda Khurd, Nanded",
  landmark: "Opposite Walkaway Showroom, Salasar Square Building",
  footerAddress:
    "Nanded Malegaon Road, Opposite Walkaway Showroom, Salasar Square Building, Shetkari Putala, Taroda Khurd, Nanded",
  whatsapp: "917083148934",
  whatsappDisplay: "70831 48934",
  phone: "9823079438",
  phone2: "8432216030",
  googleLink: "https://share.google/5u2Xe5QiZo4Rz5HdD",
  justdialLink: "https://jsdl.in/DT-9997CX6WGRU",
  instagram: "https://www.instagram.com/_amol_shembatwad?igsi=MWc1MTVyZXZoNzAybg==",
  facebook: "https://www.facebook.com/share/1K31L3dpxW/",
  mapEmbed:
    "https://www.google.com/maps?q=Salasar%20Square%20Building%2C%20Malegaon%20Road%2C%20Taroda%20Khurd%2C%20Nanded%2C%20Maharashtra%20431605&output=embed",
  opd: { days: "Monday to Saturday", morning: "10:00 AM – 5:00 PM", evening: "7:00 PM – 9:00 PM" },
};

export const waLink = (text) =>
  `https://wa.me/${HOSPITAL.whatsapp}?text=${encodeURIComponent(text || "Namaste! I would like to book an appointment at Shri Sai Chest and Allergy Hospital.")}`;

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/procedures", label: "Procedures" },
  { to: "/facilities", label: "Facilities" },
  { to: "/results", label: "Results" },
  { to: "/reviews", label: "Reviews" },
  { to: "/book-appointment", label: "Book Appointment" },
  { to: "/contact", label: "Contact" },
];

export const DOCTOR = {
  name: "Dr. Amol Shembatwad",
  specialization: "Asthma, Allergy and Respiratory Disease Specialist",
  qualification: "MBBS, MD (Pulmonology)",
  trainedAt: "MBBS, MD — KEM Hospital, Mumbai",
  allergyCourse: "AASC (Bangalore) — Allergy Asthma Specialist Course (Bangalore)",
  interventional: "Trained in Bronchoscopy, Thoracoscopy, and EBUS procedures at Pune",
  criticalCare: "Trained to handle terminal ICU cases at Mumbai",
  mmc: "2015030806",
  experience: "10+ years in Respiratory Diseases",
  designation: "Director and Senior Pulmonologist, Shri Sai Chest and Allergy Hospital, Nanded",
};

export const SERVICES = [
  { en: "Asthma", mr: "दमा" },
  { en: "COPD", mr: "सीओपीडी (श्वासनलिकांचा जुनाट आजार)" },
  { en: "ILD", mr: "इंटरस्टिशियल लंग डिसीज" },
  { en: "Allergy Disorders", mr: "ॲलर्जी विकार" },
  { en: "Respiratory Allergy", mr: "श्वसन ॲलर्जी" },
  { en: "Allergic Rhinitis", mr: "ॲलर्जिक र्हायनाइटिस" },
  { en: "Pneumothorax", mr: "न्यूमोथोरॅक्स" },
  { en: "Pneumonia", mr: "न्यूमोनिया" },
  { en: "Bronchopneumonia", mr: "ब्रॉन्कोन्यूमोनिया" },
  { en: "Pleural Effusion", mr: "प्ल्युरल इफ्युजन" },
  { en: "Bronchiectasis", mr: "ब्रॉन्काइक्टेसिस" },
  { en: "ARDS", mr: "एआरडीएस" },
  { en: "Occupational Lung Disease", mr: "व्यावसायिक फुफ्फुस आजार" },
  { en: "Fungal Pneumonia", mr: "बुरशीजन्य न्यूमोनिया" },
  { en: "ABPA", mr: "एबीपीए" },
  { en: "Eosinophilic Lung Diseases", mr: "इओसिनोफिलिक फुफ्फुस आजार" },
  { en: "Pulmonary Eosinophilia", mr: "पल्मोनरी इओसिनोफिलिया" },
  { en: "Viral Fevers", mr: "विषाणूजन्य ताप" },
  { en: "Food Allergies", mr: "अन्न ॲलर्जी" },
  { en: "Tuberculosis", mr: "क्षयरोग" },
  { en: "Lung Fibrosis", mr: "फुफ्फुस फायब्रोसिस" },
  { en: "Pulmonary Emphysema", mr: "पल्मोनरी एम्फिसीमा" },
  { en: "Aspiration Pneumonitis", mr: "ॲस्पिरेशन न्यूमोनायटिस" },
  { en: "Aspiration Pneumonia", mr: "ॲस्पिरेशन न्यूमोनिया" },
  { en: "Pulmonary Hypertension", mr: "पल्मोनरी हायपरटेन्शन" },
  { en: "Shortness of Breath", mr: "श्वास लागणे" },
  { en: "Obstructive Sleep Apnea (OSA)", mr: "ऑब्स्ट्रक्टिव्ह स्लीप अ‍ॅप्निया" },
  { en: "Excessive Sleepiness", mr: "अतिरिक्त झोप येणे" },
  { en: "Anaphylactic Shock", mr: "ॲनाफिलेक्टिक शॉक" },
  { en: "Hypersensitivity Pneumonitis", mr: "हायपरसेन्सिटिव्हिटी न्यूमोनायटिस" },
  { en: "Sleep Study Examination", mr: "स्लीप स्टडी तपासणी" },
];

export const TOP_CONDITIONS = [
  { en: "Asthma", mr: "दमा", icon: Wind },
  { en: "COPD", mr: "सीओपीडी", icon: Activity },
  { en: "ILD", mr: "इंटरस्टिशियल लंग डिसीज", icon: ScanLine },
  { en: "Allergic Rhinitis", mr: "ॲलर्जिक र्हायनाइटिस", icon: Droplets },
  { en: "Pneumonia", mr: "न्यूमोनिया", icon: HeartPulse },
  { en: "Bronchiectasis", mr: "ब्रॉन्काइक्टेसिस", icon: Stethoscope },
  { en: "Tuberculosis", mr: "क्षयरोग", icon: ShieldCheck },
  { en: "Sleep Apnea (OSA)", mr: "स्लीप अ‍ॅप्निया", icon: Moon },
];

export const PROCEDURES = [
  {
    name: "Bronchoscopy",
    icon: ScanLine,
    desc: "A thin, flexible scope is gently passed through the nose or mouth to directly examine your airways and lungs — helping diagnose infections, blockages and lung disease with precision.",
  },
  {
    name: "Fibreoptic Bronchoscopy",
    icon: Microscope,
    desc: "Advanced fibre-optic imaging gives a high-definition live view inside the bronchial tree, enabling targeted biopsies, lavage and accurate diagnosis of complex chest conditions.",
  },
  {
    name: "Foreign Body Removal",
    icon: ShieldCheck,
    desc: "Safe, swift endoscopic removal of objects accidentally inhaled into the airway — a life-saving emergency procedure, especially for children, performed under expert monitoring.",
  },
  {
    name: "Thoracocentesis",
    icon: Droplets,
    desc: "Careful drainage of excess fluid collected around the lungs (pleural effusion) to relieve breathlessness instantly and send samples for accurate laboratory diagnosis.",
  },
  {
    name: "Thoracoscopy",
    icon: Activity,
    desc: "Minimally invasive keyhole examination of the pleural space around the lungs — for diagnosing persistent fluid, thickening or masses that scans alone cannot explain.",
  },
  {
    name: "Endobronchial and Transbronchial Lung Biopsy",
    icon: Stethoscope,
    desc: "A specialized bronchoscopic technique used to collect tissue samples from the airway wall or lung tissue for accurate diagnosis of infections, tumors, and interstitial lung diseases.",
  },
];

export const FACILITIES = [
  { name: "Mon to Saturday Daily Chest OPD", icon: CalendarCheck, desc: "Daily outpatient consultations for chest and respiratory conditions, available Monday through Saturday." },
  { name: "20 Beds", icon: BedDouble, desc: "Comfortable in-patient beds with attentive nursing care." },
  { name: "IPD", icon: BedDouble, desc: "Indoor patient department for admissions and monitored recovery." },
  { name: "Intensive Care", icon: HeartPulse, desc: "Close-monitoring intensive care for critically ill patients." },
  { name: "Respiratory ICU", icon: Activity, desc: "Dedicated ICU for severe asthma, COPD and respiratory failure." },
  { name: "24×7 Emergency Respiratory Care", icon: Ambulance, desc: "Round-the-clock emergency response for breathing emergencies." },
  { name: "24×7 Emergency Service", icon: Ambulance, desc: "Emergency services available day and night, every day." },
  { name: "24×7 Diagnostic Services", icon: Microscope, desc: "Diagnostics and testing available at any hour." },
  { name: "24 Hrs Centralised Oxygen", icon: Wind, desc: "Uninterrupted central oxygen pipeline to every bed." },
  { name: "Complete Health Check-up", icon: Stethoscope, desc: "Full-body preventive health check-up packages." },
  { name: "Blood Sample Collection", icon: TestTube, desc: "On-site pathology sample collection and reporting." },
  { name: "Vaccination", icon: Syringe, desc: "Adult and respiratory-preventive vaccination services." },
  { name: "Pediatric Allergy & Asthma Diagnosis and Treatment", icon: Baby, desc: "Specialised allergy and asthma care for children — accurate diagnosis, skin prick testing and long-term treatment plans." },
];

export const GALLERY = [
  { src: "/images/image-2.webp", caption: "ICU — clean, comfortable monitored beds" },
  { src: "/images/image-5.webp", caption: "ICU & Ward — wide view of our intensive care floor" },
  { src: "/images/image-9.webp", caption: "24×7 Emergency — respiratory care at Bed No. 4" },
  { src: "/images/image-3.webp", caption: "FOT (Forced Oscillometry Test) — chairside diagnostic testing" },
  { src: "/images/image-10.webp", caption: "Procedure & Diagnostic Suite — fully equipped bronchoscopy room" },
  { src: "/images/image-11.webp", caption: "Sterile bronchoscopy instrument set — procedure-ready" },
];

export const RESULTS_CASES = [
  { key: "asthma", title: "Asthma Management", before: "/images/result-asthma-before.webp", after: "/images/result-asthma-after.webp", note: "Hyperinflated, inflamed airways settle into clear, normally expanded lungs after guided inhaler therapy." },
  { key: "pneumonia", title: "Pneumonia Recovery", before: "/images/result-pneumonia-before.webp", after: "/images/result-pneumonia-after.webp", note: "Dense lung consolidation fully resolves with timely antibiotics and respiratory support." },
  { key: "tb", title: "TB Treatment", before: "/images/result-tb-before.webp", after: "/images/result-tb-after.webp", note: "Upper-lobe tubercular lesions heal completely after a supervised full course of therapy." },
  { key: "allergy", title: "Allergy Relief", before: "/images/result-allergy-before.webp", after: "/images/result-allergy-after.webp", note: "Chronic allergic airway inflammation clears with identification of triggers and targeted treatment." },
  { key: "broncho", title: "Bronchoscopy Recovery", before: "/images/result-broncho-before.webp", after: "/images/result-broncho-after.webp", note: "An airway foreign body is removed endoscopically — the lung re-expands fully within days." },
];

export const DOCTOR_VIDEOS = [
  { id: "bronchoscopy", label: "Bronchoscopy", desc: "Live bronchoscopy procedure by Dr. Amol Shembatwad", videoFile: "/assets/bronchoscopy.mp4", videoFileWebm: "/assets/bronchoscopy.webm", poster: "/assets/bronchoscopy-poster.webp" },
  { id: "tour", label: "Thoracoscopy", desc: "Live thoracoscopy procedure by Dr. Amol Shembatwad", videoFile: "/assets/hospital-tour.mp4", videoFileWebm: "/assets/hospital-tour.webm", poster: "/assets/hospital-tour-poster.webp" },
];

export const TESTIMONIAL_VIDEOS = [
  { id: "t1", label: "Patient Testimonial", desc: "A patient shares their recovery experience at our hospital, in their own words.", videoFile: "/assets/patient-testimonial.mp4", videoFileWebm: "/assets/patient-testimonial.webm", poster: "/assets/patient-testimonial-poster.webp" },
  { id: "t3", label: "Patient Experience", desc: "Inside our clinic — a patient's visit, examination and care journey.", videoFile: "/assets/patient-experience.mp4", videoFileWebm: "/assets/patient-experience.webm", poster: "/assets/patient-experience-poster.webp" },
];

export const BOOKING_SLOTS = (() => {
  const to12h = (h, m) => `${h % 12 === 0 ? 12 : h % 12}:${m} ${h >= 12 ? "PM" : "AM"}`;
  const slots = [];
  for (let h = 10; h < 17; h++) {
    ["00", "30"].forEach((m) => slots.push({ value: to12h(h, m), label: to12h(h, m), period: "Morning OPD" }));
  }
  for (let h = 19; h < 21; h++) {
    ["00", "30"].forEach((m) => slots.push({ value: to12h(h, m), label: to12h(h, m), period: "Evening OPD" }));
  }
  return slots;
})();

export const CONSULTATION_TYPES = [
  "OPD Consultation",
  "Respiratory Consultation",
  "Allergy Consultation",
  "Follow-up Consultation",
  "Other",
];

export const STATIC_REVIEWS = [
  { id: "seed-1", name: "Janhvi Chavan", rating: 5, source: "Google",
    text: "Dr. Amol Shembatwad is an excellent chest specialist. My asthma is finally under control after years of struggle. He explains everything patiently and the hospital is very clean and well managed." },
  { id: "seed-2", name: "Atul Halne", rating: 5, source: "Google",
    text: "Best hospital for allergy and breathing problems in Nanded. My father's COPD treatment was handled with great care. Staff is supportive and emergency service is truly 24x7." },
  { id: "seed-3", name: "Saiprasad Iralwad", rating: 5, source: "Google",
    text: "I visited for allergic rhinitis treatment. The doctor diagnosed the root cause quickly and the treatment worked within weeks. Very professional and humble doctor. Highly recommended." },
  { id: "seed-4", name: "Lokesh", rating: 2, source: "Google",
    text: "Had to wait longer than expected during evening OPD hours. Treatment was fine but waiting time can be improved." },
];

export const OPD_HIGHLIGHT = { icon: Clock };
